import React, { useCallback, useEffect, useState } from 'react';
import {
  Button,
  Loader,
  SidePane,
  ScrollableDynamicTable,
  SearchableSelect,
  TOAST as Alert,
  TOAST,
  Navigation,
} from 'retro';
import { get, post } from 'App/Network/Axios';
import OpenIcon from '@atlaskit/icon/glyph/open';
import ViewRequest from '../ContractedRequest';
import Moment from 'moment';
import { Highlight } from 'App/Pages/App/MetaApis/HotelQueue/Queued/Utils';
import { DownloadCsv } from 'retro/Utils';
import RBAC from 'App/HOCs/RBAC';
import ROLES from 'App/Constants/Roles';
import Filter from 'retro/Filter';
import FilterDropDown from 'App/Components/Filter/FilterDropDown';

export default function Unassigned() {
  let [loading, setLoading] = useState(true);
  const [id, setId] = useState(undefined);
  const [assignModal, setAssignModal] = useState(false);
  const [admins, setAdmins] = useState([]);
  const [admin, setAdmin] = useState(undefined);
  const [search, setSearch] = useState({
    page: 0,
    sort: 'createdAt',
    order: 'desc',
  });
  const [Data, SetData] = useState({
    total: 0,
    currentPage: 0,
    totalPages: 0,
    items: [],
  });
  const [filterModal,setFilterModal] = useState(false);
  const [filter, setFilter] = useState({
		client: [],
		checkin: []
	});
  useEffect(() => {
    get(
      `/admins/all`,
      (e, r) => {
        if (r) {
          setAdmins(r.items);
        }
      },
      {}
    );
  }, []);
  const loadPage = useCallback(
    (search) => {
      const clientIds = filter.client.map(client => client.id);
      get(
        `meta/contracted/unassigned`,
        (e, r) => {
          if (r) {
            SetData({
              ...r,
              total: r.total || Data.total,
              totalPages: r.totalPages || Data.totalPages,
            });
            setLoading(false);
          } else {
            Alert.handleError(e);
          }
        },
        {
          offset: search.page,
          sort: search.sort,
          order: search.order,
          q: search.q,
          start: filter.checkin.length > 0 
          ? Moment().valueOf().toString()
					: undefined,
			    end: filter.checkin.length > 0 
          ? filter.checkin[0] === 'Upcoming 24 hours' 
            ? Moment().add(24, 'hours').valueOf().toString() 
            : Moment().add(48, 'hours').valueOf().toString()
				  : undefined,
			    clientIds: clientIds.length > 0 ? clientIds : undefined
        }
      );
    },
    [Data, SetData, filter.checkin, filter.client]
  );
  useEffect(() => {
    loadPage(search);
  }, [search, filter.checkin, filter.client]);
  if (loading) {
    return <Loader />;
  }
  return (
    <div
    style={{
      width: 'calc(100vw - 475px)',
    }} 
    className='overScrollY'>
      <div className='mb2 relative'>
        <Navigation title='Unassigned' />
        <RBAC role={ROLES.REPORTS}>
          <Button
            onClick={() => {
              setLoading(true);
              get(`meta/contracted/unassigned`, (e, r) => {
                if (r) {
                  let data = [];
                  const headers = [
                    'Request Id',
                    'City',
                    'Hotel Name',
                    'Hotel Address',
                    'GSTIN',
                    'Client Code',
                    'Guest Name',
                    'Guest Email',
                    'Entity',
                    'Travel Date',
                    'Request Date',
                  ];
                  data.push(headers);
                  r.items.forEach((item) => {
                    let line = [];
                    line.push([item?.requestId || '-']);
                    line.push([item.hotel?.city || '-']);
                    line.push([item.hotel?.name || '-']);
                    line.push([item.hotel?.address || '-']);
                    line.push([item.gstDetails?.gstin || '-']);
                    line.push([item.client.clientCode]);
                    line.push([item.guests[0].name]);
                    line.push([item.guests[0].email]);
                    line.push(item.entity || '-');
                    line.push(
                      `${item?.searchRequest?.dates?.in} - ${item?.searchRequest?.dates?.out}`
                      );
                    line.push(
                      Moment(item.createdAt).format('DD MMM YYYY HH:mm a')
                    );
                    data.push(line);
                  });
                  DownloadCsv(
                    `unassigned${Moment().format('DD_MM_YYYY')}}.csv`,
                    data
                  );
                }
                setLoading(false);
              });
            }}
            loading={loading}
            className='btn btn-primary btn-sm absolute top-2 right-0'
            style={{ zIndex: 10 }}
          >
            <i className='fa fa-download mr1' />
            Download Data
          </Button>
        </RBAC>
      </div>
      <Filter
  			margin="0 -4rem"
	  		onSearch={(q) => {
        setSearch({
          ...search,
          page: 0,
          q,
          });
        }}
			  onFilter={() => {
				  setFilterModal(true)
			  }}
		  />

		<FilterDropDown
			shown={filterModal}
			filters={filter}
			setFilters={setFilter}
			choices={{
				client: [],
				checkin: [
					{
						title: 'Upcoming 24 hours',
						type: 'radio'
					},
					{
						title: 'Upcoming 48 hours',
						type: 'radio'
					}
				]
			}}
			types={["Client", "CheckIn"]}
			onClose={() => {
				setFilterModal(false);
			}}
		/>
      <ScrollableDynamicTable
        setSearch={(search) => {
          setSearch({
            ...search,
            page: 0,
          });
        }}
        search={search}
        tableStyle={{
          borderSpacing: 0,
        }}
        setPage={(page) => {
          setSearch({
            ...search,
            page,
          });
        }}
        data={{
          current: Data.currentPage,
          total: Data.totalPages,
          items: Data.items.map((item) => {
            const click = () => {
              setId(item.queueId);
            };
            return {
              content: item,
              render: [
                {
                  children: (
                    <div>
                      <Highlight item={item} />
                      <p className='text fw-bold'>{item.referenceId}</p>
                      <p className='text'>{item.hotel?.city || '-'}</p>

                      <p className='text-small text-light'>
                        {item.hotel?.name || '-'}
                      </p>
                      <p className='text-small text-light'>
                        {item.hotel?.address || '-'}
                      </p>
                    </div>
                  ),
                  weight: 2,
                },
                {
                  weight: 1.5,
                  children: (
                    <div>
                      <p>{item.client.clientCode}</p>
                      <p className='text-small'>{item.guests[0].name}</p>
                      <p className='text-small'>{item.guests[0].email}</p>
                    </div>
                  ),
                },

                {
                  weight: 1.5,
                  children: (
                    <>
                      <p>{item.entity || '-'}</p>
                    </>
                  ),
                },
                {
                  weight: 1,
									title: `${item?.searchRequest?.dates?.in} - ${item?.searchRequest?.dates?.out}`,
                },
                {
                  weight: 1,
                  title: Moment(item.createdAt).format('DD MMM YYYY HH:mm a'),
                },

                {
                  weight: 1,
                  children: (
                    <div>
                      <Button
                        onClick={() => {
                          setAssignModal(item.queueId);
                        }}
                        className='btn-sm btn btn-primary'
                      >
                        Assign
                      </Button>
                    </div>
                  ),
                },
                {
                  weight: 1,
                  buttons: [
                    {
                      title: 'View',
                      className: 'btn-secondary btn-sm',
                      before: <OpenIcon size='small' />,
                      onClick: click,
                    },
                  ],
                  actions: [
                    {
                      title: 'Quick Actions',
                      actions: [
                        {
                          title: 'View',
                          before: <OpenIcon size='small' />,
                          onClick: click,
                        },
                      ],
                    },
                  ],
                },
              ],
            };
          }),
        }}
        headers={[
          {
            weight: 2,
            title: 'Details',
          },
          {
            weight: 1.5,
            title: 'Client',
          },
          {
            weight: 1.5,
            title: 'Entity/Gst Details',
          },
          {
            weight: 1,
            title: 'Travel Date',
          },
          {
            weight: 1,
            title: 'Request Date',
            sort: 'createdAt'
          },
          {
            weight: 1,
            title: 'Automate',
          },
          {
            weight: 1,
            title: 'Actions',
            style: {
              justifyContent: 'end',
            },
          },
        ]}
      />
      {id !== undefined && (
        <ViewRequest
          id={id}
          onClose={() => {
            setId(undefined);
            loadPage(search);
          }}
        />
      )}
      {assignModal && (
        <SidePane
          description='Assign ticket to some other user'
          overflow={true}
          width={400}
          onClose={() => {
            setAssignModal(undefined);
          }}
          title='Assign Ticket'
          blank={true}
        >
          <div className='pd4'>
            <SearchableSelect
              label='Select Admin'
              selected={admin}
              onSelect={setAdmin}
              list={admins}
              labelKey='name'
            />
            <Button
              onClick={() => {
                if (admin) {
                  post(
                    `/meta/contracted/${assignModal}/${admin.id}/assign`,
                    {},
                    (e, r) => {
                      if (r) {
                        loadPage(search);
                        setAssignModal(undefined);
                      } else {
                        TOAST.handleError(e);
                      }
                    },
                    {}
                  );
                }
              }}
              margin='mt4'
              className='btn btn-primary'
            >
              Assign Ticket
            </Button>
          </div>
        </SidePane>
      )}
    </div>
  );
}
